<template>
  <div class="dashboard">
    <router-view></router-view>
    <!-- <Index/> -->
  </div>
</template>

<script>
 /* eslint-disable */
 import Index from '@/components/locales/Index.vue';

export default {
  name: "locales",
  components:{
    Index
  }
};
</script>
